var Bavaria = "Бавария";
var Berlin = "Берлин";
var Brandenburg = "Бранденбург";
var Bremen = "Бремен";
var Hamburg = "Гамбург";
var Hesse = "Гессен";
var Saarland = "Саар";
var Saxony = "Саксония";
var Thuringia = "Тюрингия";
var DEStates = {
	"Baden-Wuerttemberg": "Баден-Вюртемберг",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "Мекленбург-Передняя Померания",
	"Lower Saxony": "Нижняя Саксония",
	"North Rhine-Westphalia": "Северный Рейн-Вестфалия",
	"Rhineland-Palatinate": "Рейнланд-Пфальц",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "Саксония-Ангальт",
	"Schleswig-Holstein": "Шлезвиг-Гольштейн",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
